import { Share } from '@capacitor/share';

/**
 * Android share implementation using Capacitor Share plugin
 * Android doesn't support excludedActivityTypes like iOS
 */
export async function share(options) {
  const shareData = {};
  if (options.title) shareData.title = options.title;
  if (options.text) shareData.text = options.text;
  if (options.url) shareData.url = options.url;
  
  await Share.share(shareData);
  return { presented: true };
}
